import React from "react";
import "./../../styles/pages/NextJourney.css";
import "./../../styles/pages/CustomPage.css";

const ActivitiesPage = () => {
  return (
    <div className="msf-container">
      <div className="msf-row">
        <div className="msf-text">
          {/* Encabezado */}
          <h2 className="custom-page-h2">
            Próxima edición del Camino: junio de 2026
          </h2>
          <h3>Muxia-Fisterra-Santiago</h3>
          <div className="red-line"></div>
          
          {/* Información sobre fechas mejorada */}
          <div className="journey-highlight-box">
            <div className="journey-dates-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
                <circle cx="12" cy="16" r="4"></circle>
              </svg>
            </div>
            <div className="journey-dates-content">
              <h4 className="journey-dates-title">Fechas del Camino</h4>
              <p className="journey-dates-text">
                20 - 27 de junio de 2026
              </p>
              <p className="journey-days-text">
                8 dias | 6 etapas | 141,5 Km de ruta (35 Km en barco)
              </p>
            </div>
          </div>
          
          {/* Descripción del camino */}
          <p>
            La “Variante Espiritual” del Camino Portugués une dos Caminos
            Jacobeos: el Camino Portugués y la “Ruta del Mar”, el Origen de
            Todos Los Caminos. En el año 44 después de Cristo, la Ría de Arousa
            fue surcada por el barco que transportaba el cuerpo de Santiago
            Apóstol. Sus restos fueron trasladados por sus discípulos, quienes
            conducidos por un ángel y guiados por una estrella arribaron a las
            costas de Galicia y subieron por el cauce del río Ulla hasta
            alcanzar Iria Flavia (actual villa de Padrón).
          </p>
          <p>
            Se navega por un paraje natural de gran belleza. Se descubren
            molinos, fuentes, capillas y monasterios. Se caminar a través de
            bosques, viñedos y playas. Es el recorrido Via Crucis
            marítimo-fluvial es único del mundo, en el que se podrá contemplar
            los 17 cruceros centenarios que identifican este Camino de Santiago
            como la “Translatio”, el Origen de Todos Los Caminos.
          </p>
          
          {/* Tabla resumen */}
          <div className="next-journey-table">
            <h3>Resumen de la ruta</h3>
            <div className="table-responsive">
              <table className="route-table">
                <thead>
                  <tr>
                    <th colSpan="3">Días</th>
                    <th>Salidas</th>
                    <th>Llegadas</th>
                    <th>Etapas</th>
                    <th>Noche en</th>
                    <th>Km</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1º</td>
                    <td>20-jun</td>
                    <td>Sábado</td>
                    <td>Bus</td>
                    <td>Sevilla</td>
                    <td>Pontevedra</td>
                    <td>Pontevedra</td>
                    <td>751</td>
                  </tr>
                  <tr>
                    <td>2º</td>
                    <td>21-jun</td>
                    <td>Domingo</td>
                    <td>Etapa 1</td>
                    <td>Porto Mougás</td>
                    <td>A Ramallosa</td>
                    <td>Pontevedra</td>
                    <td>16</td>
                  </tr>
                  <tr>
                    <td>3º</td>
                    <td>22-jun</td>
                    <td>Lunes</td>
                    <td>Etapa 2</td>
                    <td>Redondela</td>
                    <td>Pontevedra</td>
                    <td>Pontevedra</td>
                    <td>19,8</td>
                  </tr>
                  <tr>
                    <td>4º</td>
                    <td>23-jun</td>
                    <td>Martes</td>
                    <td>Etapa 3</td>
                    <td>Pontevedra</td>
                    <td>Armenteira</td>
                    <td>Pontevedra</td>
                    <td>20,5</td>
                  </tr>
                  <tr>
                    <td>5º</td>
                    <td>24-jun</td>
                    <td>Miércoles</td>
                    <td>Etapa 4</td>
                    <td>Armenteira</td>
                    <td>Villanova de Arousa</td>
                    <td>Santiago</td>
                    <td>23,4</td>
                  </tr>
                  <tr>
                    <td>6º</td>
                    <td>25-jun</td>
                    <td>Jueves</td>
                    <td>Etapa 5</td>
                    <td>Villanova de Arousa</td>
                    <td>Padrón</td>
                    <td>Santiago</td>
                    <td>35 Barco - 2,4 a pie</td>
                  </tr>
                  <tr>
                    <td>7º</td>
                    <td>26-jun</td>
                    <td>Viernes</td>
                    <td>Etapa 6</td>
                    <td>Padrón</td>
                    <td>Santiago</td>
                    <td>Santiago</td>
                    <td>24,4</td>
                  </tr>
                  <tr>
                    <td>8º</td>
                    <td>27-jun</td>
                    <td>Sábado</td>
                    <td>Bus</td>
                    <td>Santiago</td>
                    <td>Sevilla</td>
                    <td>Casa</td>
                    <td>888</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          {/* PDF descargable */}
          <div className="pdf-download-container">
            <h3>Guía de recomendaciones para el Camino</h3>
            <p>
              Hemos preparado una guía completa con todo lo esencial para preparar tu mochila 
              y organizar el equipaje para tu experiencia en el Camino de Santiago. 
              Incluye recomendaciones sobre ropa, calzado, accesorios y otros elementos importantes.
            </p>
            <a href="/docs/recomendaciones.pdf" download className="pdf-download-button">
              <span className="download-icon">↓</span> Descargar guía del Camino (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivitiesPage;
